<template>
  <v-container fluid>
    <v-row>
      <!-- filter -->
      <v-col cols="12" md="3">
        <wapi-panel :title="'Фильтр'">
          <template v-slot:content>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-select
                v-model="userId"
                :items="users"
                item-text="name"
                item-value="id"
                label="Клиент"
                :rules="[rules.required]"
                dense
                outlined
                @change="changeUser"
              ></v-select>
              <wapi-presets
                v-model="presetId"
                :disabled="!userId"
                :multiple="multiple"
                @input="onChangePreset"
                :userId="userId"
                :rules="[rules.required]"
                close-after-select
              />
              <wapi-date-picker v-model="lastTime" :label="`Срок последнего прогноза`" disabled></wapi-date-picker>
            </v-form>
          </template>
        </wapi-panel>
      </v-col>
      <!-- query props -->
      <v-col cols="12" md="9">
        <wapi-panel :title="'Настройки запроса'" :spacing="false">
          <template v-slot:content>
            <!-- map -->
            <v-row>
              <v-col>
                <div style="height: 415px;">
                  <l-map
                    ref="map"
                    :zoom="13"
                    :center="center"
                    @click="click"
                    :class="'wapi_map__map'"
                  >
                    <l-tile-layer url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"></l-tile-layer>
                    <l-geo-json ref="geoJsonLayer" :geojson="geojson" :options="geoJsonOptions" />
                    <l-marker
                      v-for="marker in markers"
                      v-bind:key="marker.id"
                      :lat-lng="[marker.latitude, marker.longitude]"
                      @click="selectMarkerHandler(marker)"
                      :icon="marker.icon"
                    ></l-marker>
                  </l-map>
                </div>
              </v-col>
            </v-row>
            <!-- buttons -->
            <v-row class="pl-2">
              <v-col>
                <v-btn class="ma-2" color="primary" @click="loadResult()">Выполнить запрос</v-btn>
              </v-col>
            </v-row>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
    <v-row class="ml-2">
      <v-col>
        <wapi-panel :title="'Результаты'" :spacing="false" v-if="forecast.parameters">
          <template v-slot:content>
            <v-tabs background-color="primary" dark>
              <v-tab>Таблица</v-tab>
              <v-tab>JSON</v-tab>
              <v-tab-item>
                <forecast-tabs v-model="tabIndex" :model="forecast"></forecast-tabs>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <json-viewer :value="json" copyable boxed expanded :expand-depth="5" sort></json-viewer>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../../models/contract/WapiContract";
import rules from "../../models/helpers/rules";
import settings from "../../settings.json";
import { datePickerDate } from "../../helpers/common";
import WapiPanel from "../../components/WapiPanel";
import WapiDatePicker from "../../components/WapiDatePicker";
import ForecastTabs from "../../components/ForecastTabs";
import WapiForecastMessageViewModel from "../../models/viewmodels/WapiForecastMessageViewModel.js";
import WapiPresets from "../../components/WapiPresets.vue";
import Point from "../../models/point.js";
import L from "leaflet";

export default {
  name: "ForecastLongPresetView",
  title: "Долгосрочные прогнозы для пресета",
  components: {
    WapiPanel,
    ForecastTabs,
    WapiDatePicker,
    WapiPresets
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
  },
  data: function() {
    return {
      tabIndex: 0,
      markerLatLng: settings.center,
      dateStart: datePickerDate(),
      dateEnd: datePickerDate(),
      menuDateStart: false,
      menuDateEnd: false,
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          this.$refs.map.mapObject.fitBounds(bounds);
        }
      },
      dvariants: [],
      predicts: [],
      users: [],
      userId: "",
      latitude: settings.center[0],
      longitude: settings.center[1],
      geojson: null,
      valid: true,
      rules: rules,
      multiple: false,
      center: settings.center,
      result: [],
      lastTime: null,
      json: {},
      forecast: [],
      presets: [],
      presetId: "",
      presetsViewModel: [],
      markers: [],
      iconSelectedMarker: L.icon({
        iconUrl: "/marker-icon-red.png"
      })
    };
  },
  methods: {
    async selectMarkerHandler(point) {
      this.tabIndex = point.id;
      this.selectMarker(point.id);
    },

    async selectMarker(id) {
      this.markers.forEach(x => {
        if (x.id === id) {
          x.icon = this.iconSelectedMarker;
        } else {
          x.icon = new L.Icon.Default();
        }
      });
    },
    async onChangePreset(presetId) {
      try {
        if (!presetId) return;

        await this.$store.dispatch("FETCH_PRESET", {
          id: presetId,
          user_id: this.userId
        });
        this.preset = this.$store.getters.PRESET;
        this.geojson = this.preset.geoJson;
        this.bounds = this.$refs.geoJsonLayer.getBounds();
      } catch (err) {
        this.$store.dispatch("PUSH_ERROR", err);
      }
    },
    async loadResult() {
      if (!this.$refs.form.validate()) return;
      const params = {
        userId: this.userId,
        presetId: this.presetId
      };

      await this.$store.dispatch("SET_LOADING", true);
      this.result = await this.$store.dispatch(
        "FETCH_FORECAST_LONG_PRESET_USER",
        params
      );
      this.json = this.result;

      if (!this.json) {
        await this.$store.dispatch(
          "PUSH_ERROR_MESSAGE",
          "Нет данных для отображения"
        );
        await this.$store.dispatch("SET_LOADING", false);
        return;
      }

      this.forecast = new WapiForecastMessageViewModel().map(this.result);

      let number = 0;
      this.markers = this.forecast.pointGroups.map(p => {
        const point = new Point();
        point.id = number++;
        point.latitude = p.latitude;
        point.longitude = p.longitude;
        point.icon = new L.Icon.Default();
        return point;
      });

      await this.$store.dispatch("SET_LOADING", false);
    },
    async loadLastTime() {
      this.lastTime = await this.$store.dispatch(
        "FETCH_FORECAST_LONG_LAST_TIME_USER",
        this.userId
      );
    },
    async changeUser(userId) {
      if (!userId) return;
      this.loadLastTime();
    },
    click(event) {
      this.latitude = event.latlng.lat;
      this.longitude = event.latlng.lng;
      this.markerLatLng = [this.latitude, this.longitude];
    }
  },
  watch: {
    tabIndex(value) {
      if (value) {
        this.selectMarker(value);
      }
    }
  },
  computed: {
    presetEnabled: function() {
      const result = this.presets.length > 0;
      return result;
    }
  }
};
</script>